import React from 'react';
import ReactDOM from 'react-dom/client';

import FleetLocalizationProvider from '@carrier-io/air-react/FleetLocalizationProvider';
import FleetThemeProvider from '@carrier-io/air-react/theme/FleetThemeProvider';
import { StyledEngineProvider } from '@carrier-io/air-react/styles';
import '@carrier-io/air-react/fonts/index.css';

import { ApolloProvider } from '@apollo/client';
import App from './App';
import client from './apollo/apolloClient';

const rootEl = document.getElementById('root');

if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <ApolloProvider client={client}>
        <FleetLocalizationProvider>
          <StyledEngineProvider injectFirst>
            <FleetThemeProvider>
              <App />
            </FleetThemeProvider>
          </StyledEngineProvider>
        </FleetLocalizationProvider>
      </ApolloProvider>
    </React.StrictMode>,
  );
} else {
  console.error('Root element not found');
}
